import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../constants";

const detectBots = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  console.log(userAgent);

  // Whitelist of good bots
  const goodBots = [
    /googlebot/i,
    /bingbot/i,
    /duckduckbot/i,
    /baiduspider/i,
    /yandexbot/i,
  ];

  // List of known bad bot user-agent patterns
  const badBotPatterns = [
    /bot/i,
    /spider/i,
    /crawl/i,
    /headless/i,
    /phantomjs/i,
    /selenium/i,
    /puppeteer/i,
    /curl/i,
    /wget/i,
    /python-requests/i,
    /libwww-perl/i,
    /httpclient/i,
    /scrapy/i,
    /nmap/i,
    /nikto/i,
    /zaproxy/i,
    /arachni/i,
    /dirbuster/i,
    /burpsuite/i,
    /netsparker/i,
    /acunetix/i,
    /sqlmap/i,
    /fuzzer/i,
    /masscan/i,
    /xray/i,
    /shodan/i,
    /censys/i,
    /metasploit/i,
    /recon-ng/i,
    /paros/i,
    /httpunit/i,
    /blackhat/i,
    /checker/i,
    /scan/i,
    /hunter/i,
    /probe/i,
    /flood/i,
    /brute/i,
    /attack/i,
    /harvest/i,
    /collector/i,
    /monitor/i,
    /crawler4j/i,
    /webcopy/i,
    /webstripper/i,
    /sitecheck/i,
    /httprider/i,
    /httptrace/i,
    /feedfinder/i,
    /grabber/i,
    /searchtool/i,
    /havij/i,
    /parser/i,
    /botify/i,
    /fetch/i,
    /tracker/i,
    /scanbot/i,
    /scoutjet/i,
    /authedmine/i,
    /miner/i,
    /browserbench/i,
    /loadtester/i,
    /stress/i,
  ];

  // Allow good bots
  if (goodBots.some((pattern) => pattern.test(userAgent))) {
    return false;
  }

  // Block bad bots
  return badBotPatterns.some((pattern) => pattern.test(userAgent));
};

const useBotProtection = () => {
  useEffect(() => {
    if (detectBots()) {
      console.log("Bad bot detected!");
      //window.location.href = "/blocked"; // Redirect to a blocked page
      //navigate("/black-hole");
      void blockIp();
    } else {
      //navigate("/black-hole");
      console.log("Welcome!");

      //void blockIp();
    }
  }, []);

  const blockIp = async () => {
    const response = await fetch(
      `${API_BASE_URL}/app/api/block-ip`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      }
    );
  };

  return null; // This component runs silently
};

export default useBotProtection;
